module.exports = __webpack_public_path__ + "assets/images/pages/hearthy/hearthy-1.png?c2f703f0";